import * as APITypes from "~/API";
import type { EntityListData } from "~/types";
import { getPropertyEntityList } from "./handlers/getPropertyEntityList";
import { getBuildingEntityList } from "./handlers/getBuildingEntityList";
import { getUnitEntityList } from "./handlers/getUnitEntityList";
import { getServiceRequestEntityList } from "./handlers/getServiceRequestEntityList";
import { getAmenityEntityList } from "./handlers/getAmenityEntityList";
import { getUnitPlanEntityList } from "./handlers/getUnitPlanEntityList";
import { getParcelEntityList } from "./handlers/getParcelEntityList";

const EMPTY_ENTITY_LIST: EntityListData = {
  propertyList: [],
  buildingList: [],
  unitList: [],
  serviceRequestList: [],
  amenityList: [],
  unitPlanList: [],
  parcelList: [],
  propertyMap: {},
  buildingMap: {},
  unitMap: {},
  parcelMap: {},
};

export const getEntityList = async ({
  entityType,
  ownerID,
  ownerType,
}: {
  entityType: APITypes.EntityType;
  ownerID: string;
  ownerType: APITypes.OwnerType;
}): Promise<EntityListData> => {
  switch (entityType) {
    case APITypes.EntityType.Property:
      return getPropertyEntityList(ownerID, ownerType);

    case APITypes.EntityType.Building:
      return getBuildingEntityList(ownerID, ownerType);

    case APITypes.EntityType.Unit:
      return getUnitEntityList(ownerID, ownerType);

    case APITypes.EntityType.ServiceRequest:
      return getServiceRequestEntityList(ownerID, ownerType);

    case APITypes.EntityType.Amenity:
      return getAmenityEntityList(ownerID, ownerType);

    case APITypes.EntityType.UnitPlan:
      return getUnitPlanEntityList(ownerID, ownerType);

    case APITypes.EntityType.Parcel:
      return getParcelEntityList(ownerID, ownerType);

    default:
      return EMPTY_ENTITY_LIST;
  }
};
